import React from 'react'

import webbg from "../assets/img/webbg.png";
import webbg2 from "../assets/img/webbg2.png";
import staranimate from "../assets/img/staranimate.png";

import icon1 from "../assets/img/ser1.png";
import icon2 from "../assets/img/ser2.png";
import icon3 from "../assets/img/ser3.png";
import icon4 from "../assets/img/ser4.png";
import icon5 from "../assets/img/ser5.png";
import icon6 from "../assets/img/ser6.png";
import design from "../assets/img/design.jpg";
import socialmeida from "../assets/img/socialmeida.jpg";
import seo from "../assets/img/seo.jpg";
import joinbutton from "../assets/img/joinbutton.png";
import eli2 from "../assets/img/eli2.png";
import { Link } from 'react-router-dom';


import { Helmet } from "react-helmet-async";

export default function Service() {
  return (
    <>
        <Helmet>
            <title>Service | Stock Cod</title>
            <meta name="description" content="Expert Web Development Services Available in Ghaziabad with StockCod" />
        </Helmet>
        <section className="inntepagesection">
            <div className="outerofinnterpage" style={{
                backgroundImage: `url(${webbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}>
                <div className="background-overlay overlay-about-bnr"></div>
                <div className="container">
                    <div className="innerpagecontent">
                        <div className="staranimate">
                            <img src={staranimate} alt='star icon' />
                        </div>
                        <h2>Our Service</h2>
                        <ul>
                            <li>
                                <Link to="/">Home <span>></span></Link>
                            </li>
                            <li>
                                <Link to="/service">Our Service</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section> 


        <section className="servsection sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}
        >
            <div className="background-overlay overlay-service"></div>
            <div className="overlayset2" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            >
                    </div>
            <div className="outerofservices">
                <div className="container">
                    <div className="sectionheading heading-mb">
                        <h2>What <span>we do</span></h2>
                        <p>The importance of SEO services for companies seeking to attract new customers and increase traffic cannot be overstated.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon1} alt="Web Site Development" />
                                </div>
                                <div className="sercontent">
                                    <h3>Web Site Development</h3>
                                    <p>Your company's website is one of the most effective tools for establishing a strong internet presence. A professional web design will assist you in making a favorable first impression on your target audience.</p>
                                    <div className="webbtn1">
                                        <Link to="/website-development">Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon2} alt="Search Engine Optimization" />
                                </div>
                                <div className="sercontent">
                                    <h3>Search Engine Optimization</h3>
                                    <p>Increase your website's visibility and organic traffic with our results-driven Search Engine Optimization service.
                                    Dominate search engine rankings and stay ahead of the competition with our expert SEO strategies.</p>
                                    <div className="webbtn1">
                                        <a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon3} alt="Graphic Design" />
                                </div>
                                <div className="sercontent">
                                    <h3>Graphic Design</h3>
                                    <p>Graphic design is essential in modern marketing and gives businesses a competitive advantage. Your company requires appealing images, efficient idea communication, and increased trust to drive traffic to your brand.</p>
                                    <div className="webbtn1">
                                    <a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon4} alt="Video Editing" />
                                </div>
                                <div className="sercontent">
                                    <h3>Video Editing</h3>
                                    <p>Experience professional-grade Video Editing with our expert team, delivering polished and captivating videos for all your needs.
                                    Transform your raw footage into stunning visual stories with our top-notch Video Editing service.</p>
                                    <div className="webbtn1">
                                    <a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon5} alt="Mothion Graphic" />
                                </div>
                                <div className="sercontent">
                                    <h3>Mothion Graphic</h3>
                                    <p>Enhance your brand's visual appeal with our professional Motion Graphic service, crafting dynamic animations that stand out from the crowd.
                                    Transform your ideas into captivating motion visuals with our expert team.</p>
                                    <div className="webbtn1">
                                    <a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
                            <div className="servicebox">
                                <div className="sericon">
                                    <img src={icon6} alt="Social Media Marketing" />
                                </div>
                                <div className="sercontent">
                                    <h3>Social Media Marketing</h3>
                                    <p>Amplify your brand's presence with our Social Media Marketing service, reaching and engaging your target audience effectively.
                                    Boost your online visibility & drive results with our expert Social Media Marketing strategies.</p>
                                    <div className="webbtn1">
                                    <a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="outerofcounterdown about-us-counter">
                <div className="count-area" data-diff="100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6 col-md-3 achivmentouterbox">
                                <div className="count-area-content">
                                    <div className="counterbox">
                                        <div className="count-digit">2</div>
                                        <span>+</span>
                                    </div>
                                    <div className="count-title">Year of Experience</div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 achivmentouterbox">
                                <div className="count-area-content">
                                    <div className="counterbox">
                                        <div className="count-digit">80</div>
                                        <span>+</span>
                                    </div>
                                    <div className="count-title">Happy Client</div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 achivmentouterbox">
                                <div className="count-area-content">
                                    <div className="counterbox">
                                        <div className="count-digit">150</div>
                                        <span>+</span>
                                    </div>
                                    <div className="count-title">Complete Project</div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3 achivmentouterbox">
                                <div className="count-area-content">
                                    <div className="counterbox">
                                        <div className="count-digit">10</div>
                                        <span>+</span>
                                    </div>
                                    <div className="count-title">Team Members</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
        <section style={{
            backgroundImage: `url(${webbg2})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
        }}
        >
            <div className="classNameouterofservicepack">
                <div className="containerouterset">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="servicpackbox">
                                <div className="content">
                                    <a href="#!">
                                    <div className="content-overlay"></div>
                                    <img className="content-image" src={design} alt="web designing" />
                                    <div className="content-details fadeIn-right">
                                        <div className="flexlistbody">
                                            <h3>Design</h3>
                                            <ul>
                                                <li><span>✓</span> UI / UX Design</li>
                                                <li><span>✓</span> E-commerce Website Design</li>
                                                <li><span>✓</span> Website Wireframe Design</li>
                                                <li><span>✓</span> Portfolio Website Design</li>
                                                <li><span>✓</span> Company Profile Design</li>
                                                <li><span>✓</span> Landing Page Design</li>
                                                <li><span>✓</span> Logo Design</li>
                                            </ul>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="servicpackbox">
                                <div className="content">
                                    <a href="#!">
                                    <div className="content-overlay"></div>
                                    <img className="content-image" src={socialmeida} alt="social media marketing" />
                                    <div className="content-details fadeIn-right">
                                        <div className="flexlistbody">
                                            <h3>Social Media</h3>
                                            <ul>
                                                <li><span>✓</span> Social Media Optimisation</li>
                                                <li><span>✓</span> Social Media posting & scheduling</li>
                                                <li><span>✓</span> Dedicated Calendar for LinkedIn</li>
                                                <li><span>✓</span> Social Media Campaign Strategy</li>
                                                <li><span>✓</span> Marinating post frequency</li>
                                                <li><span>✓</span> Social Media Marketing</li>
                                                <li><span>✓</span> Video post Production</li>
                                                <li><span>✓</span> Social Media Calendar</li>
                                                <li><span>✓</span> Reel View Campaign</li>
                                                <li><span>✓</span> Hashtag research</li>
                                            </ul>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="servicpackbox">
                                <div className="content">
                                    <a href="#!">
                                    <div className="content-overlay"></div>
                                    <img className="content-image" src={seo} alt="search engine optimization" />
                                    <div className="content-details fadeIn-right">
                                        <div className="flexlistbody">
                                            <h3>SEO</h3>
                                            <ul>
                                                <li><span>✓</span> Search Engine Optimization</li>
                                                <li><span>✓</span> Keyword Research</li>
                                                <li><span>✓</span> Offpage</li>
                                                <li><span>✓</span> Onpage</li>
                                                <li><span>✓</span> Search engines & their algorithms</li>
                                                <li><span>✓</span> Technical Pragmatic</li>
                                                <li><span>✓</span> Search Engine Marketing</li>
                                                <li><span>✓</span> Performance Max</li>
                                                <li><span>✓</span> SEO tools and analytics</li>
                                            </ul>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundSize: "ConvolverNode",
            backgroundRepeat: "no-repeat",
        }} 
        >
            <div className="background-overlay overlay-about-us"></div>
            <div className="outerofcalltoactionjoin">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
                            <div className="joinuscontent">
                                <div className="sectionheading">
                                    <h2>Want to join?</h2>
                                </div>
                                <p>Find a team of digital marketers you can rely on. Every day, we build trust through communication, transparency, and results.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="joinbutton">
                                <div className="joinbuttonimg">
                                    <img src={joinbutton} alt="" />
                                </div>
                                <div className="webbtn">
                                    <Link to="/contact-us">Get Started</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
